export default __webpack_public_path__ + "static/media/dashboard.91aaf056.png";